// @flow

import React, { Component, createContext } from 'react';
import { isEmpty } from 'lodash';
import { get } from 'js-cookie';

export type AuthInfo = {
  isAuthenticated: boolean,
  authCookie: string,
};

type Props = {
  children?: any,
};

type State = AuthInfo;

const { Provider, Consumer } = createContext({
  isAuthenticated: false,
  authCookie: '',
});

class Auth extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const authCookie = get('simpalsid.auth') || '';
    const isAuthenticated = !isEmpty(authCookie);
    this.state = {
      isAuthenticated,
      authCookie,
    };
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}

export const withAuth = (ComposedComponent: any) => (props: any) => (
  <Consumer>{auth => <ComposedComponent {...props} auth={auth} />}</Consumer>
);

export { Consumer as AuthConsumer };

export default Auth;



// WEBPACK FOOTER //
// ./src/contexts/Auth/index.js